module.exports = __webpack_public_path__ + "img/11-4.3d914c74.png";